import { icons } from "assets";
import React from "react";
import { useNavigate } from "react-router-dom";
import Button from "../button";
import Modal from "../modal";
import Text from "../text";
import styles from "./successful.module.css";



export const ErrorModal = ({setOpenModal, openModal, close, route, message, setErrorModal}) => {

  const navigate = useNavigate()

  

  return (
    <Modal
      open={openModal}
      onClose={() => setOpenModal(false)}
      disableBackdropClick
    >
      <div style={{ textAlign: "center" }}>
        <div>
          <img src={icons.error} style={{ width: "90px", height: "90px" }} />
        </div>
        <Text variant="lg" style={{ fontWeight: "600" }}>
          Error Occured
        </Text>
        <Text
          variant="xs"
          style={{ color: "var(--social-color)", paddingTop: "1rem" }}
        >
          {message}
        </Text>
      </div>

      <div
        className="row-start"
        style={{
          justifyContent: "center",
          marginTop: "2rem",
        }}
      >
        <div className={styles.flexButton}>
          <Button
            label="Close"
            className={(styles.button, styles.cancel)}
            onClick={() => setErrorModal(false)}
          />
        </div>
      </div>
    </Modal>
  );
};
